/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default } from './lozenge';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type {
	NewLozengeProps,
	LozengeColor as NewLozengeColor,
	LozengeSpacing,
	SemanticColor,
	AccentColor,
} from './types';
